import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

export function withRouter(Component) {
  const Wrapper = (props, ref) => {
    let navigate, location, params;

    try {
      navigate = useNavigate();
      location = useLocation();
      params = useParams();
    } catch {
      navigate = () => {};
      location = { pathname: '', search: '', query: {} };
      params = {};
    }

    const query = {};
    const searchParams = new URLSearchParams(location.search);
    for (const [key, value] of searchParams.entries()) {
      query[key] = value;
    }

    const path = location.pathname.startsWith('/') ? location.pathname.slice(1) : location.pathname;
    const route = { path };
    const router = {
      location: { ...location, query },
      push: (url) => navigate(url),
      replace: (url) => navigate(url, { replace: true }),
      goBack: () => navigate(-1)
    };

    return <Component {...props} router={router} route={route} location={{ ...location, query }} params={params} routeParams={params} ref={ref} />;
  };

  const Forwarded = React.forwardRef(Wrapper);
  const keysToExclude = ['propTypes', 'contextTypes', 'defaultProps'];
  Object.keys(Component).forEach(key => {
    if (keysToExclude.indexOf(key) === -1) {
      Forwarded[key] = Component[key];
    }
  });
  Forwarded.displayName = `withRouter(${Component.displayName || Component.name || 'Component'})`;

  return Forwarded;
}
